export function buildErrorInfo(
  err: IMediaError,
  techErr: IMediaError,
  sourceUrl: string,
  contentType: string
) {
  const isExpired = isSourceUrlExpired(err, sourceUrl);
  const errTitle = isExpired
    ? "sourceUrl is expired."
    : techErr?.message || err?.message || "Unknown error.";
  const errInfo = {
    err: err,
    src: sourceUrl,
    type: contentType,
    isSourceUrlExpired: isExpired,
    techErr: null as IMediaError,
  };
  if (techErr) {
    // techErrはDOMのMediaErrorの場合があり、キーが列挙可能ではないことがあるので、個別にマッピングする。
    errInfo.techErr = {
      code: techErr.code,
      message: techErr.message,
      metadata: techErr.metadata,
      status: techErr.status,
      responseText: techErr.responseText,
    };
  }
  return {
    errTitle,
    errInfo,
    isExpired,
  };
}

function isSourceUrlExpired(err: IMediaError, sourceUrl: string) {
  // MKIOロケーターは有効期限後に410を返す
  if (err?.status === 410) {
    return true;
  }

  // SAS付きURLの場合、クエリパラメータから取得する
  const sasExpiresAtStr = sourceUrl
    ? new URL(sourceUrl).searchParams.get("se")
    : null;
  if (sasExpiresAtStr) {
    return new Date(sasExpiresAtStr) <= new Date();
  }
  return false;
}

interface IMediaError {
  code: number;
  message: string;

  // 以下は通常のMediaErrorにはないvideo.jsの独自フィールド
  status?: unknown; // video.jsの型定義では any[] だが実際には number のことがあるので unknown にして型エラー回避
  responseText?: string;
  metadata?: Record<string, unknown>;
}
